import { ExtrasFormDataType } from './SpaPackageModal.types';

export const calculateExtraPrices = (extras: ExtrasFormDataType): number =>
  Object.values(extras || {})
    .flatMap((extras) => extras?.map((extra) => extra.price))
    .reduce((acc, cur) => (cur?.amount || 0) + acc, 0);
